import { render, staticRenderFns } from "./bidangkegiatan.vue?vue&type=template&id=4c8e6466"
import script from "./bidangkegiatan.vue?vue&type=script&lang=js"
export * from "./bidangkegiatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports